import { useMediaQuery, useTheme } from '@material-ui/core';
import { MARGE_SIZE, SIDE_WIDTH, SMALL_SIDE_WIDTH } from '../utils/constants';

export default ({ visWidth, isFull }) => {
  const theme = useTheme();
  const isDownXS = useMediaQuery(theme.breakpoints.down('xs'));
  const isBetweenSMMD = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isOnlyMD = useMediaQuery(theme.breakpoints.only('md'));
  const isUpLG = useMediaQuery(theme.breakpoints.up('lg'));

  if (isDownXS) {
    console.log('dowxn xs');
    return { maxWidth: 'none' };
  }

  if (isBetweenSMMD) {
    return {
      left: `${MARGE_SIZE}%`,
      maxWidth: visWidth,
    };
  }

  if (isOnlyMD) {
    return {
      left: isFull
        ? `${MARGE_SIZE}%`
        : `calc(${MARGE_SIZE}% + ${SMALL_SIDE_WIDTH + theme.spacing(2)}px)`,
      maxWidth: visWidth - (isFull ? 0 : SMALL_SIDE_WIDTH) - theme.spacing(2),
    };
  }

  if (isUpLG) {
    return {
      left: isFull
        ? `${MARGE_SIZE}%`
        : `calc(${MARGE_SIZE}% + ${SIDE_WIDTH + theme.spacing(2)}px)`,
      maxWidth: visWidth - (isFull ? 0 : SIDE_WIDTH) - theme.spacing(2),
    };
  }
};
